import search from './components/search/sagas'
import object from './components/object/sagas'

export default function* rootSaga() {
  yield [
    search(), object()
    // add your saga here
  ];
}
